<template>
  <div>
    <dx-grid
      url="branches"
      :columns="columns"
      :title="title"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      ref="grid"
    ></dx-grid>
    <v-dialog persistent v-model="updateBranchDialog" max-width="500">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Update {{ clickedBranch.branchDesc }}</v-card-title
        >
        <v-layout row class="mb-3 ma-0 pa-0">
          <!-- <v-btn
                        small
                        icon
                        color="red"
                        class="mr-2"
                        v-if="clickedBranch.branchRecordingFile"
                        @click="clickedBranch.branchRecordingFile = null"
                    >
                        <v-icon right>mdi-close-circle</v-icon>
                    </v-btn> -->
          <v-btn
            v-if="clickedBranch.branchRecordingFile"
            @click="clickedBranch.branchRecordingFile = null"
            flat
            class="mr-2"
            icon
            color="red"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <audio
            class="mr-3"
            v-if="clickedBranch.branchRecordingFile"
            controls
            :src="clickedBranch.branchRecordingFile"
          ></audio>
          <v-btn
            small
            outline
            class="mr-2"
            :loading="uploading"
            @click="pickFile()"
          >
            Upload
            <v-icon right dark>mdi-cloud-upload</v-icon>
          </v-btn>
          <input
            type="file"
            style="display: none"
            ref="files"
            accept=".mp3"
            @change="onFilePicked($event)"
          />
        </v-layout>
        <v-select
          class="mx-2"
          hide-details
          v-model="clickedBranch.listType"
          label="List Type"
          :items="['Teacher', 'Section']"
          clearable
        ></v-select>
        <v-checkbox
          class="mx-2 mt-3"
          hide-details
          v-model="clickedBranch.inactive"
          label="Inactive"
          color="success"
        ></v-checkbox>
        <v-card-actions class="mx-0 px-2 pb-2 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="updateBranchDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="save()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";

export default {
  data: () => ({
    title: "Branches",

    actions: [],

    updateBranchDialog: false,
    clickedBranch: "",
    processing: false,
    uploading: false,
    files: [],

    columns: [
      {
        label: "Branch Code",
        field: "branchCode",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Description",
        field: "branchDesc",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Hebrew Description",
        field: "branchDescH",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Recording",
        template: "link-audio-cell-template",
        field: "branchRecordingFile",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "List Type",
        field: "listType",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "File Name",
        field: "fileName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Inactive",
        field: "inactive",
        visible: true,
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  mounted() {},
  beforeDestroy() {},
  created() {},
  methods: {
    onRowClicked(branch) {
      this.clickedBranch = JSON.parse(JSON.stringify(branch));
      this.updateBranchDialog = true;
    },
    pickFile() {
      this.$refs.files.click();
    },
    async onFilePicked(e) {
      this.uploading = true;

      const files = e.target.files;

      if (!files) return;

      try {
        var formData = new FormData();

        formData.append("upload_file", files[0]);

        const response = await this.$http.post(
          "api/adminPortal/UploadFile?convertMp3=true",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.clickedBranch.branchRecordingFile = response.url;
        this.uploading = false;
      } catch (e) {
        this.uploading = false;
      }
    },
    async save() {
      try {
        this.processing = true;

        await this.$http.post("api/branches/saveBranch", this.clickedBranch);

        this.updateBranchDialog = false;
        this.processing = false;

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
  },
};
</script>
<style>
.gray-fg {
  color: #999;
}
</style>
